module.exports = __webpack_public_path__ + "static/media/Group 37402.84e211de.svg";